// Colors that can be used if there's no image for the Fact
export const HEADER_PLACEHOLDER_COLOR_CLASSES = ['error', 'alert', 'success', 'highlight', 'primary', 'gray'];

// Status of trying to copy a URL
export enum URL_COPIED_STATUS {
  SUCCESS = 'success',
  ERROR = 'error'
}
